import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { invoicesMainRoute } from '..';

export const invoicesSettingsRoute = createRoute({
  getParentRoute: () => invoicesMainRoute,
  path: 'settings',
  component: lazyRouteComponent(() => import('./InvoiceSettingsView')),
});
